import React from 'react';
import { translate } from '../Services/translation';

const SellingPoints = ({ yearlyProduction }) => {
  return (
    <>
      <section className="sunpanel-selling-points">
        <div className="sunpanel-selling-points__item">
          <div className="yearly-production__icon" />
          <div className="sunpanel-selling-points__text">
            {translate('solcellepanel.estimated.offer.yearlyproduction')}
          </div>
          <div className="sunpanel-selling-points__data-text">
            {yearlyProduction} kWh
          </div>
        </div>
      </section>
    </>
  );
};

export default SellingPoints;
